import React from 'react';
import cn from 'classnames';
import { renderFromComponentMap } from '@goodrx/x-core';
import { DisclosureLinkWithDrawer } from './components/DisclosureLinkWithDrawer';
export const DisclosureLink = /*#__PURE__*/React.memo(props => {
  const {
    className,
    displayTitle,
    subtitle,
    copy,
    type
  } = props;
  const componentMap = {
    default: () => /*#__PURE__*/React.createElement(DisclosureLinkWithDrawer, {
      className: cn(className, 'disclosureLinkWithDrawerType'),
      displayTitle: displayTitle,
      subtitle: subtitle
    }, copy)
  };
  return renderFromComponentMap(componentMap, type || 'default');
});